/**
 * 相关api
 * 请求方式
 * POSTFORM，POSTJSON，GET
 */
import * as API from "szyx-axios";
import {
  ApiRequest,
  SuccesBase,
  ErrBase,
  SuccesNotify,
  ErrNotify
} from "../base/baseModel";

export default {
  ApiRequest,
  SuccesBase,
  ErrBase,
  SuccesNotify,
  ErrNotify,
  // 企业注册
  register: params => {
    return API.POSTJSON("/cpia/company/register", params);
  },
  // 企业用户登录
  login: params => {
    return API.POSTFORM("/cpia/user/login", params);
  },
  //退出
  loginOut: params => {
    return API.GET("/cpia/user/logout", params);
  },
  // 省份列表
  province: params => {
    return API.GET("/cpia/common/province", params);
  },
  // 城市列表
  city: params => {
    return API.POSTFORM("/cpia/common/city", params);
  },
  // 发送短信验证码
  sendSms: params => {
    return API.POSTFORM("/cpia/common/sendSms", params);
  },
  // 获取图片验证码
  getCodePic: params => {
    return API.GET("/cpia/common/getCodePic", params);
  },
  // 会员企业列表
  memberList: params => {
    return API.GET("/cpia/company/memberList", params);
  },
  // 忘记密码
  resetPwd: params => {
    return API.POSTFORM("/cpia/user/resetPwd", params);
  },

  // 保存企业信息
  enterpriseSave: params => {
    return API.POSTJSON("/cpia/company/save", params);
  },
  // 审核通过企业列表
  memberList: params => {
    return API.GET("/cpia/company/memberList", params);
  },
  // 查询企业信息
  memberInfo: params => {
    return API.POSTFORM("/cpia/company/info", params);
  },
  // 保存企业信息草稿数据
  cacheSave: params => {
    return API.POSTJSON("/cpia/company/cache", params);
  },
  // 贷款进度详情
  loanInfo: params => {
    return API.POSTFORM("/cpia/company/loanInfo", params);
  },
   // 融资进度
   loanProgress: params => {
    return API.POSTFORM("/cpia/company/loanProgress", params);
  }
  
  
};



// WEBPACK FOOTER //
// ./src/api/api.js